import React from 'react'
import Artist from './Artist'
import ArtistDelete from './ArtistDelete'
import { Grid, GridCol } from '../common/Grid'
import { List, ListItem } from '../common/List'

const ArtistsList = props => (
    <List>
        {props.artists.map((artist, idx) => (
            <ListItem key={idx}>
                <Grid className="has-vcenter">
                    <GridCol className="is-min">
                        <i className="material-icons">person_pin</i>
                    </GridCol>
                    <GridCol>
                        <Artist id={artist.id} artists={props.artists} />
                    </GridCol>
                    <GridCol className="has-text-right">
                        <ArtistDelete id={artist.id} />
                    </GridCol>
                </Grid>
            </ListItem>
        ))}
    </List>
)

export default ArtistsList


// WEBPACK FOOTER //
// ./src/components/artists/ArtistsList.js